import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Row, Col } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import newsData from '../data/news.json';
import '../css/News.css';

const News = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');
    const siteUrl = 'https://www.tangwell.com.tw';
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: newsData.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@type': 'NewsArticle',
                headline: item.titleCh,
                datePublished: item.date.replace(/\./g, '-'),
                url: `${siteUrl}${isEnglish ? '/en' : ''}/news/${item.slug}`
            }
        }))
    };

    return (
        <div className="news-page">
            <Helmet>
                <title>{isEnglish ? 'News' : '最新消息'}</title>
                <meta name="description" content={isEnglish ? "Read the latest Tang Wu Biotech news, food safety updates, certifications, and global catering ingredient developments." : "即時掌握湯武生技餐飲原料與食品安全動態新聞，瞭解最新認證、研發與產業合作資訊。"} />
                <meta name="keywords" content={isEnglish ? "news, food safety, industry updates" : "最新消息, 產業動態"} />
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            {/* 頂部橫幅區 */}
            <div className="news-banner">
                <div className="banner-content">
                    {isEnglish ? (
                        <>
                            <div className="big-title-en">News</div>
                        </>
                    ) : (
                        <>
                            <div className="title-en">News</div>
                            <h1 className="big-title-ch">最新消息</h1>
                        </>
                    )}
                </div>
            </div>

            <div className="news-container container-wide">
                <Row gutter={[0, 40]}>
                    {newsData.map((item) => {
                        const newsUrl = isEnglish ? `/en/news/${item.slug}` : `/news/${item.slug}`;
                        return (
                            <Col span={24} key={item.id}>
                                <div className="news-card" onClick={() => navigate(newsUrl)}>
                                    <Row gutter={[40, 0]} align="middle">
                                        {/* 左側文字區：佔 16 份 */}
                                        <Col xs={24} md={16}>
                                            <div className="news-text-content">
                                                {/* 分類標籤 */}
                                                <div className="news-tag">{isEnglish ? item.categoryEn : item.categoryCh}</div>

                                                {/* 標題區 */}
                                                <div className="title-ch mb-5">{item.titleCh}</div>
                                                <div className="title-en mb-20">{item.titleEn}</div>

                                                {/* 日期 */}
                                                <div className="news-date content-en">{item.date}</div>
                                            </div>
                                        </Col>

                                        <Col xs={24} md={8}>
                                            {/* 右側縮圖 */}
                                            {item.imgName && (
                                                <div className="news-image-box">
                                                    <img
                                                        src={require(`../images/NewsPage/${item.imgName}`)}
                                                        alt={item.titleCh}
                                                        loading="lazy"
                                                    />
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </div>
    );
};

export default News;